module.exports = __webpack_public_path__ + "media/images/sports_coaching/cover-desktop-6ad65891fe995dd6c6300658ae028331.jpg";